<template>
  <div>
    <div class="c_page-title">
      <div>急救箱日志</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="选择城市"
                  >
                    <el-option
                      v-for="item in optionsMap.options_supply_city"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pgid" placeholder="代采组">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="val in optionsMap.options_pg_group"
                      :key="val.value"
                      :label="val.label"
                      :value="val.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.pg_member_id" placeholder="代采员">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="val in optionsMap.options_pg_member"
                      :key="val.value"
                      :label="val.label"
                      :value="val.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-input
                    v-model="form.operator"
                    placeholder="操作人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select v-model="form.oper_type" placeholder="操作方式">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in optionsMap.options_oper_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.source_type" placeholder="操作来源">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in optionsMap.options_source_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="操作日期">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.planid"
                    placeholder="代采计划编号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="output">导出</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.goods_img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="oper_type"
              label="操作方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="source_type"
              label="操作来源"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="plan_type"
              label="代采计划生成方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="planid"
              label="代采计划编号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="plan_create_time"
              label="计划生成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_type"
              label="是否特价商品"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="reason"
              label="加入急救箱原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator"
              label="操作人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              width="200px"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :page-sizes="[10, 50, 100]"
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper,sizes"
            :total="resData.total"
            :page-size="10"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { postOptionsForPlanCancelLogList } from "@/openapi/erp/log.js";

export default {
  data() {
    return {
      resData: { list: [], count: 0 },
      form: {
        page: 1,
        page_size: 10,
        source: "",
        create_time: this.$excalibur.getDateRange(2, true), // 创建时间
        city: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Log/getPlanCancelLogList",
      status: "",
      curPage: 1,
      market_id: "",
      filterFold: false,
      oper_type_option: [
        { key: 1, label: "加入急救箱" },
        { key: 2, label: "恢复" },
      ],
      source_type_option: [
        { key: 1, label: "代采版" },
        { key: 2, label: "erp后台" },
        { key: 3, label: "爆版" },
      ],
      optionsMap: {},
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.getSelectionOptions();
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http
        .post("/erp/Log/getPlanCancelLogList", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    fetchData(showLoading) {
      this.form.is_excel = 0;
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.form.spid = [];
      val.forEach((v) => {
        this.form.spid.push(v.supply_id);
      });
      this.multipleSelection = val;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData();
    },
    search() {
      this.form.is_excel = 0;
      this.form.page = 1;
      this.fetchData();
    },
    // 获取筛选项
    getSelectionOptions() {
      postOptionsForPlanCancelLogList()
        .then((res) => {
          this.optionsMap = res;
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/log/PlanOperLogList.vue